import styled from "@emotion/styled";

export const StyledLayout = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  width: 100%;

  /* overflow: hidden; */
`;

export const StyledSectionContainer = styled.section`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  width: 100%;
  /* overflow: hidden; */

  padding: 4rem 0rem;

  @media screen and (max-width: 1250px) {
    padding: 4rem 2rem;
  }

  @media screen and (max-width: 768px) {
    padding: 2rem 20px;
  }
`;

export const SectionHeading = ({ title, description }) => {
  return (
    <StyledHeading>
      <h2 className={"title"}>{title}</h2>
      <p className={"subtitle"}>{description}</p>
    </StyledHeading>
  );
};

const StyledHeading = styled.section`
  width: 100%;

  & .title {
    font-size: 4rem;
    color: #fff;
    color: #d3d3d3;
    /* text-align: center; */
    /* margin-bottom: 2.5rem; */
  }
  & .subtitle {
    font-size: 1.2rem;
    max-width: 900px;
    color: #fff;
    color: #e3e3e3;
  }

  @media screen and (max-width: 900px) {
    & .title {
      font-size: 2.5rem;
      color: #fff;
      /* text-align: center; */
      /* margin-bottom: 2.5rem; */
    }
    & .subtitle {
      font-size: 1rem !important;
      max-width: 900px;
      color: #fff;
    }
  }
`;
